module.exports = __webpack_public_path__ + "static/media/Just Jump.2ca7d12d.jpg";